import { create } from 'zustand'

export interface PendingApproval {
  approval_id: string
  tool_call_id: string | null
  capability_id: string
}

interface ApprovalToastState {
  pending: PendingApproval | null
  surface: (a: PendingApproval) => void
  dismiss: () => void
}

export const useApprovalToastStore = create<ApprovalToastState>((set) => ({
  pending: null,
  surface: (a) => set({ pending: a }),
  dismiss: () => set({ pending: null }),
}))
